import { axiosInstance } from 'src/util/axios/instance.axios'
import { TeamDashboardMetrics, TeamDashboardSkillGapMetrics, TeamDashboardTeamMetrics } from '../model/my-team-dashboard'
import { RatingChart } from '../model/my-team-skill-gaps'

export async function getTeamDashboardMetrics(): Promise<TeamDashboardMetrics> {
  const { data } = await axiosInstance.request<TeamDashboardMetrics>({
    url: `/my-team/team-dashboard-metrics/`,
  })

  return data
}

export async function getTeamDashboardSkillGapMetrics(): Promise<TeamDashboardSkillGapMetrics> {
  const { data } = await axiosInstance.request<TeamDashboardSkillGapMetrics>({
    url: `/my-team/team-dashboard-skill-gap-metrics/`,
  })

  return data
}

export async function getTeamDashboardTeamMetrics(): Promise<TeamDashboardTeamMetrics> {
  const { data } = await axiosInstance.request<TeamDashboardTeamMetrics>({
    url: `/my-team/team-dashboard-team-metrics/`,
  })

  return data
}

export type UserNotification =
  | {
    id: string
    date: string
    type: 'skill-assessment'
    skillSetId: string
    skillSetName: string
  }
  | {
    id: string
    date: string
    type: 'skill-validation'
    userId: string
    userName: string
    roleId: string
    roleName: string
  }
  | {
    id: string
    date: string
    type: 'performance-review'
    templateId: string
    templateName: string
    reason: 'assigned' | 'updated'
  }
  | {
    id: string
    date: string
    type: 'project-invitation'
    projectId: string
    projectName: string
  }
  | {
    id: string
    date: string
    type: 'project-response'
    projectId: string
    projectName: string
    userName: string
    response: 'accepted' | 'declined'
  }

export type UserNotificationType = UserNotification['type']

export async function getUserNotifications(): Promise<UserNotification[]> {
  const { data } = await axiosInstance.request<UserNotification[]>({
    url: `/my-team/user-notifications/`,
  })

  return data
}

export async function getTeamDashboardSkillsByRating(rating: number): Promise<RatingChart[]> {
  const { data } = await axiosInstance.request<RatingChart[]>({
    url: `/my-team/team-dashboard-skills-by-rating/?rating=${rating}`,
  })

  return data
}